import { type DropdownItem } from '@myre/ui-primitive-actions-dropdown';

import {
  computed,
  inject,
  Injectable,
  Injector,
  runInInjectionContext,
  type Signal,
} from '@angular/core';

import { subscribeToMultiObservable } from '../../../helpers/signal.helpers';

import {
  type Avatar,
  type Feed,
  type SimplifiedActionDropdownItem,
} from '../interfaces';
import { RoutingService } from '../routing/routing.service';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  private readonly _routingService = inject(RoutingService);
  private readonly _injector = inject(Injector);

  public get dropdownItems(): Signal<SimplifiedActionDropdownItem[]> {
    return this._dropdownItems;
  }

  public get selectedDropdownItem(): Signal<number | string> {
    return this._selectedDropdownItem;
  }

  public get settings(): Signal<DropdownItem[]> {
    return this._settings;
  }

  public get feed(): Signal<Feed> {
    return this._feed;
  }

  public get avatar(): Signal<Avatar> {
    return this._avatar;
  }

  public displaySearchBar(): boolean {
    return !!this._header()?.search;
  }

  private _headerForCurrentRoute = computed(() =>
    typeof this._routingService.activatedRouteDataForBaseUrl()?.header ===
    'function'
      ? runInInjectionContext(this._injector, () =>
          this._routingService.activatedRouteDataForBaseUrl()?.header(),
        )
      : null,
  );

  private _header = subscribeToMultiObservable(this._headerForCurrentRoute);

  private readonly _dropdownItems = computed(() => {
    return this._header()?.dropdownItems;
  });

  private readonly _selectedDropdownItem = computed(
    () => this._header()?.selectedDropdownItem,
  );

  private readonly _settings = computed(() => this._header()?.settings);

  private readonly _avatar = computed(() => this._header()?.avatar);

  private readonly _feed = computed(() => this._header()?.feed);
}
